import * as React from 'react';

const FigmaIcon: React.FC<React.SVGProps<SVGSVGElement>> = (props) => (
    <svg fill="none" height={28} viewBox="0 0 20 28" width={20} xmlns="http://www.w3.org/2000/svg" {...props}>
        <path
            d="M14.4707 18.6668C17.0481 18.6668 19.1374 16.5775 19.1374 14.0002C19.1374 11.4228 
            17.0481 9.3335 14.4707 9.3335C11.8934 9.3335 9.80408 11.4228 9.80408 14.0002C9.80408 
            16.5775 11.8934 18.6668 14.4707 18.6668Z"
            fill="white"
        />
        <path
            clipRule="evenodd"
            d="M5.13737 28.0001C7.7147 28.0001 9.80404 25.9107 9.80404 23.3334C9.80404 22.6299 
            9.80404 21.0743 9.80404 18.6667C7.70758 18.6667 6.15203 18.6667 5.13737 18.6667C2.56004 
            18.6667 0.470703 20.7561 0.470703 23.3334C0.470703 25.9107 2.56004 28.0001 5.13737 28.0001Z"
            fill="white"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M5.13737 18.6668H9.80404V9.3335C7.55203 9.3335 5.99648 9.3335 5.13737 
            9.3335C2.56004 9.3335 0.470703 11.4228 0.470703 14.0002C0.470703 16.5775 2.56004
            18.6668 5.13737 18.6668Z"
            fill="white"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M5.13737 9.33333H9.80404V0C7.55203 0 5.99648 0 5.13737 0C2.56004 0 0.470703 
            2.08934 0.470703 4.66667C0.470703 7.244 2.56004 9.33333 5.13737 9.33333Z"
            fill="white"
            fillRule="evenodd"
        />
        <path
            clipRule="evenodd"
            d="M14.4707 9.33333H9.80408V0H14.4707C17.0481 0 19.1374 2.08934 19.1374 4.66667C19.1374 
            7.244 17.0481 9.33333 14.4707 9.33333Z"
            fill="white"
            fillRule="evenodd"
        />
    </svg>
);
export default FigmaIcon;
